import React, { useState } from 'react'
import './Otp_responsiveness.css'
import logo from '../images/logo.png'
import Card from "react-bootstrap/Card";
import Form from 'react-bootstrap/esm/Form';
import { useNavigate } from 'react-router-dom';
import { deleteUser} from 'firebase/auth';
import { auth } from '../Firebase/Firebase';
import {clickFunctionSignup} from './Signup.jsx'
import { LoggedIn } from './State';


export default function OTP() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        otp: "",
    })


    const handleinput = (e) => {
        const name = e.target.name;
        const otp = e.target.value;
        
        setFormData({ ...formData, [name]: otp })
        
        if (otp.length === 6) {
            let confirmationResult = window.confirmationResult;
            confirmationResult.confirm(otp).then((result) => {
                // User signed in successfully.
                //Deleting a user process started - Extra User Generated by phone number login
                const user = auth.currentUser;
                deleteUser(user).then(() => {
                    // User deleted.
                    console.log("User Deleted");
                }).catch((error) => {
                    // An error ocurred
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log(errorCode, errorMessage);
                });
                //Deleting user code complete   
                console.log(localStorage);
                clickFunctionSignup(localStorage.getItem('email'), localStorage.getItem('password')); //Creating User with email and password signup. Email and password are collected from signup form and stored in local storage.
                localStorage.removeItem('email');
                localStorage.removeItem('password'); //Deleting from local storage once password is used
                LoggedIn.isLoggedIn = true;
                navigate("/Userdashboard", { replace: true }) //Navigate to home once signup is complete

                // ...
            }).catch((error) => {
                // User couldn't sign in (bad verification code?) Wrong OTP entered
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage);
                alert("Wrong OTP Entered")
                navigate("/signup") // Navigate to signup if OTP entered is wrong
            });
        }
    }


    return (
        <>
            <div className="otp_main">

                    <div className="ls_OTPshowcase-top">
                        <img src={logo} alt="MIT Logo"/>
                    </div>

                    <div className="ls_OTPCard1">

                        <Card className='ls_OTPcard'>
                            <Card.Body>
                                <Card.Title className="ls_OTPcardtitle"><span className='title'>OTP Verification</span></Card.Title>


                                <Form className='ls_OTPform'>
                                    <Form.Group className="ls_OTPlabelGroup" controlId="formBasicEmail" style={{
                                        
                                    }}>
                                        <Form.Label className="ls_OTPlabel">We have Sent a Verification Code to   Your Phone Number</Form.Label>
                                    </Form.Group>

                                    <Form.Group className="ls_OTPpassword" controlId="formBasicPassword">
                                        <input className='ls_OTPpasswordInput' type="password" placeholder="Enter Verification Code"
                                            name="otp" id="otp"
                                            onChange={handleinput} value={formData.otp} />
                                    </Form.Group>

                                </Form>

                            </Card.Body>
                        </Card>
                    </div>
            </div>
        </>
    )
}
